import { useState, Fragment } from "react";
import { useImagesBySignedUrl } from "../hooks/useImagesBySignedUrl";
import { Media } from "../types/media";
import { CarouselImage, PaddedContainer } from "../styles/styles";
import { useImagesByMediaId } from "../hooks/useImagesByMediaId";
import { FixaOverflowCarousel } from "@coworker/apprestructured/src/shared/wrappers/FixaCarousel/FixaCarousel";
import { DesktopImageViewer } from "./DesktopImageViewer";
import { MobileImageViewer } from "./MobileImageViewer";
import { DesktopOnly } from "@coworker/apprestructured/src/shared/components/DesktopOnly";
import { MobileOnly } from "@coworker/apprestructured/src/shared/components/MobileOnly";

interface MediaImagesCarouselProps {
  media: Media;
}

export const MediaImagesCarousel = ({ media }: MediaImagesCarouselProps) => {
  const [openModal, setOpenModal] = useState(false);
  const { data: images } = useImagesByMediaId(media.id);
  const signedUrlImages = useImagesBySignedUrl(images ?? [], "large");

  if (signedUrlImages && signedUrlImages.length === 0) return <></>;

  return (
    <>
      <PaddedContainer $py={"0px"} $px={"16px"}>
        <FixaOverflowCarousel id="imagesByMedia" data-testid="imagesByMedia">
          {signedUrlImages.map((image, index) => {
            const imageProps = {
              src: image?.url ?? "",
              $rotation: image?.rotation || 0,
              $clickable: true as const,
              fallback: !image?.url || image.url.trim() === "",
              onClick: () => setOpenModal(true),
            };

            return (
              <Fragment key={index}>
                <DesktopOnly>
                  <CarouselImage {...imageProps} $variant="desktop" />
                </DesktopOnly>
                <MobileOnly>
                  <CarouselImage {...imageProps} $variant="mobile" />
                </MobileOnly>
              </Fragment>
            );
          })}
        </FixaOverflowCarousel>
      </PaddedContainer>

      <DesktopOnly>
        {openModal && (
          <DesktopImageViewer
            images={signedUrlImages}
            isOpen={openModal}
            onClose={() => setOpenModal(false)}
          />
        )}
      </DesktopOnly>

      <MobileOnly>
        {openModal && (
          <MobileImageViewer
            images={signedUrlImages}
            isOpen={openModal}
            onClose={() => setOpenModal(false)}
          />
        )}
      </MobileOnly>
    </>
  );
};
